// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-field-recaptcha[data-v-b20a71ba]{align-items:flex-start;display:flex;flex-direction:column}.error-message[data-v-b20a71ba]{color:var(--color-error);font-size:12px;margin-top:4px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
